import {
  WORKFLOW_A,
  WORKFLOW_B,
  WORKFLOWS_ROLE_SUBCONTRACTOR,
  WORKFLOWS_ROLE_GENERAL_CONTRACTOR,
  WORKFLOWS_ROLE_CONSTRUCTION_MANAGER,
  WORKFLOWS_ROLE_ARCHITECT,
} from '../constants/roles-types';

export const superPropsFieldsMapping = {
  HOSTED_BY: 'Hosted By',
};

export const peoplePropsFieldsMapping = {
  NUM_OF_PROJECTS: 'Num. of Projects',
};

export const screenType = {
  PANEL: 'Viewer',
  PROJECT: 'Project',
  OTHER: 'N/A',
};

export const assigneeType = {
  ME: 'Me',
  MY_COMPANY: 'My Company',
  MY_ROLE: 'My Role',
  USER: 'User',
  COMPANY: 'Company',
  ROLE: 'Role',
  UNASSIGNED: 'Unassigned',
  OTHER: 'Other',
};

export const attachmentTypes = {
  UPLOAD: 'Upload',
  LINK: 'Link to Document',
};

export const emptyField = 'N/A';

export const workflowTypesMapper = {
  [WORKFLOW_A]: 'A',
  [WORKFLOW_B]: 'B',
  NONE: 'N/A',
};

export const workflowRolesOrderedByPriority = [
  WORKFLOWS_ROLE_GENERAL_CONTRACTOR,
  WORKFLOWS_ROLE_CONSTRUCTION_MANAGER,
  WORKFLOWS_ROLE_ARCHITECT,
  WORKFLOWS_ROLE_SUBCONTRACTOR,
];

export const reportFormats = {
  CSV: 'CSV',
  PDF: 'PDF',
};
